import React from "react";

export const ActionOnKeyPress = ({
	children,
	action,
	keyName,
	preventDefault = false,
	...props
}) => {
	const keyPressHandler = event => {
		if (event.key === keyName) {
			if (preventDefault) {
				event.preventDefault();
			}
			action();
		}
	};

	return (
		<div onKeyPress={keyPressHandler} {...props}>
			{children}
		</div>
	);
};
